import React, { Component } from 'react'

import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch'
import Button from '@material-ui/core/Button'

import { base } from '../../base'
import './BrandItem.css'

class BrandItem extends Component {

    constructor(props) {
        super(props)
        this.state = {
            brandItem: {}
        }
    }

    componentDidMount() {
        this.setState({brandItem: {...this.props.brandItem}}, () => {
            const { id } = this.props.brandItem;
            base.syncDoc(`/hardware/${id}`, {
                context: this,
                state: 'brandItemUpdates'
            })
        })
    }

    onChangeField = (val, key) => {
        this.setState(currentState => {
            const newState = Object.assign({}, currentState);
            newState.brandItem[key] = val
            return newState
        })
    }

    onToggleEdit = () => {
        if (this.state.editing) {
            this.setState({
                brandItemUpdates: this.state.brandItem,
                editing: false
            })
        } else {
            this.setState({
                brandItemOriginal: {...this.state.brandItem},
                editing: true
            })
        }
    }

    onCancelChanges = () => {
        this.setState({
            brandItem: this.state.brandItemOriginal
        }, () => {
            this.setState({
                editing: false
            })
        })
    }

    render() {
        const variant = "outlined"

        return (
            <Paper className="brand-item" square={true}>
                <Grid container={true} spacing={8}>
                    <Button onClick={this.onToggleEdit}>{this.state.editing ? 'save' : 'edit'}</Button>
                    {this.state.editing && <Button onClick={this.onCancelChanges}>cancel</Button>}
                    <Grid xs={12} item={true}>
                        <FormControlLabel
                            control={<Switch
                                onChange={(e, checked) => this.onChangeField(checked, 'promoted')}
                                checked={this.state.brandItem.promoted ? true : false}
                                disabled={!this.state.editing}
                            />}
                            label="Promoted"
                        />
                        <div className="field">
                            <TextField
                                value={this.state.brandItem.id || ''}
                                label="ID"
                                variant={variant}
                                fullWidth={true}
                                onChange={(e) => this.onChangeField(e.target.value, 'id')}
                                disabled={true}
                            />
                        </div>
                        <div className="field">
                            <TextField
                                value={this.state.brandItem.model || ''}
                                label="Model"
                                variant={variant}
                                fullWidth={true}
                                onChange={(e) => this.onChangeField(e.target.value, 'model')}
                                disabled={!this.state.editing}
                            />
                        </div>
                        <div className="field">
                            <TextField
                                value={this.state.brandItem.version || ''}
                                label="Version"
                                variant={variant}
                                fullWidth={true}
                                onChange={(e) => this.onChangeField(e.target.value, 'version')}
                                disabled={!this.state.editing}
                            />
                        </div>
                        <div className="field">
                            <TextField
                                value={this.state.brandItem.link || ''}
                                label="Link"
                                variant={variant}
                                fullWidth={true}
                                onChange={(e) => this.onChangeField(e.target.value, 'link')}
                                disabled={!this.state.editing}
                            />
                        </div>
                        <div className="field">
                            <TextField
                                value={this.state.brandItem.price || ''}
                                label="Price"
                                variant={variant}
                                fullWidth={true}
                                onChange={(e) => this.onChangeField(e.target.value, 'price')}
                                disabled={!this.state.editing}
                            />
                        </div>
                    </Grid>
                </Grid>
            </Paper>
        )
    }
}

export default BrandItem



// WEBPACK FOOTER //
// ./src/components/Hardware/BrandItem.js